/**
 * Centralized helpers to distinguish between the new pedagogical Expression Écrite v2
 * and the legacy/official scoring Expression Écrite v1.
 */

export function isWritingV2Result(stateOrRecord: any): boolean {
  if (!stateOrRecord) return false;
  return (
    stateOrRecord.resultType === "writing_v2" ||
    stateOrRecord.writingVersion === 2 ||
    stateOrRecord.metadata?.type === "writing_linguistic_correction" ||
    stateOrRecord.metadata?.writingVersion === 2 ||
    stateOrRecord.metadata?.isWritingTest === true ||
    stateOrRecord.metadata?.hasEE === true
  );
}

export function isLegacyWritingResult(stateOrRecord: any): boolean {
  if (!stateOrRecord) return false;
  return (
    !isWritingV2Result(stateOrRecord) &&
    (
      stateOrRecord.competency === "Expression Écrite (EE)" ||
      stateOrRecord.competence === "Writing" ||
      stateOrRecord.competency === "writing" ||
      stateOrRecord.testType?.includes?.("writing")
    )
  );
}
